import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=044d990f&lang=pug&"
import script from "./collapse-item.vue?vue&type=script&lang=js&"
export * from "./collapse-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports